"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var BonusEditor = /** @class */ (function (_super) {
    __extends(BonusEditor, _super);
    //private readonly key_messages = "messages";
    function BonusEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        return _this;
    }
    BonusEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_LBT = this.props.listBonusTypes.Subscribe("*", function (id, data) {
            _this.setState({
                _bonus_types: data.data
            });
        });
        /* this.SID_LBM = this.props.listBonusMessages.Subscribe("*", (id, data) => {
             this.setState({
                 _bonus_messages: data.data
             });
         });
 
         this.SID_LEM = this.props.listEmailMessages.Subscribe("*", (id, data) => {
             this.setState({
                 _email_messages: data.data
             });
         }); */
        //this.SID_LBP = this.props.listBonusPermissionTypes.Subscribe("*", (id, data) => {
        //    this.setState({
        //        _bonus_permissions: data.data
        //    });
        //});
        // this.SID_LAC = this.props.listAppCurrency.Subscribe("*", (id, data) => {
        //     this.setState({
        //         _currency: data.data
        //     });
        // });
        this.SID_LB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({
                _brands: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    // app_currency_id: _item.app_currency_id,
                    // app_currency_title: _item.app_currency_title,
                    bonus_ttl_hours: _item.bonus_ttl_hours,
                    bonus_type_code: _item.bonus_type_code,
                    bonus_type_title: _item.bonus_type_title,
                    description: _item.description,
                    is_bonus_has_ttl: _item.is_bonus_has_ttl,
                    is_deprecated: _item.is_deprecated,
                    is_locked: _item.is_locked,
                    is_use_freespin: _item.is_use_freespin,
                    //is_send_bonus_status_messages: _item.is_send_bonus_status_messages,
                    //bonus_status_message_set_id: _item.bonus_status_message_set_id,
                    //bonus_status_message_set_title: _item.bonus_status_message_set_title,
                    //is_send_bonus_status_emails: _item.is_send_bonus_status_emails,
                    //bonus_status_email_set_id: _item.bonus_status_email_set_id,
                    //bonus_status_email_set_title: _item.bonus_status_email_set_title,
                    _brands: [],
                    _bonus_types: [],
                    _currency: [],
                    //_bonus_messages: [],
                    //_email_messages: [],
                    //_bonus_permissions: [],
                    tabKey: this.key_main
                }, function () {
                    //this.props.listBonusMessages.LoadDataByBonusTemplateTypeCode(this.state.bonus_type_code);
                    //this.props.listEmailMessages.LoadDataByBonusTemplateTypeCode(this.state.bonus_type_code);
                    _this.props.state.setExtBreadCrumbPath(["Редактирование шаблона бонуса"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                brand_id: 0,
                brand_title: "",
                // app_currency_id: 0,
                // app_currency_title: "",
                bonus_ttl_hours: 24,
                bonus_type_code: 0,
                bonus_type_title: "",
                description: "",
                is_bonus_has_ttl: false,
                is_deprecated: false,
                is_locked: false,
                is_use_freespin: false,
                // is_send_bonus_status_messages: false,
                // bonus_status_message_set_id: 0,
                // bonus_status_message_set_title: "",
                //  is_send_bonus_status_emails: false,
                //  bonus_status_email_set_id: 0,
                //  bonus_status_email_set_title: "",
                _brands: [],
                _bonus_types: [],
                _currency: [],
                //_bonus_messages: [],
                //_email_messages: [],
                //_bonus_permissions: [],
                tabKey: this.key_main
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание шаблона бонуса"]);
            });
        }
        // this.props.listAppCurrency.LoadData();
        this.props.listBrands.LoadData();
        this.props.listBonusTypes.LoadData();
        //this.props.listBonusPermissionTypes.LoadData();
        this.doReSetRules();
    };
    BonusEditor.prototype.componentWillUnmount = function () {
        // this.props.listAppCurrency.UnSubscribe(this.SID_LAC);
        this.props.listBrands.UnSubscribe(this.SID_LB);
        this.props.listBonusTypes.UnSubscribe(this.SID_LBT);
        //this.props.listBonusMessages.UnSubscribe(this.SID_LBM);
        //this.props.listEmailMessages.UnSubscribe(this.SID_LEM);
        //this.props.listBonusPermissionTypes.UnSubscribe(this.SID_LBP);
    };
    BonusEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            bonus_type_rules: { isError: false },
            brand_rules: { isError: false },
        });
    };
    BonusEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Поле [имя] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        //  if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
        //      this.setState({
        //          app_currency_rules: { isError: true, errorMessage: "Поле [валюта] не выбрана!" },
        //          tabKey: this.key_main
        //      })
        //      return false;
        //  }
        if ((this.state.bonus_type_code <= 0) || (this.state.bonus_type_title.length === 0)) {
            this.setState({
                bonus_type_rules: { isError: true, errorMessage: "Поле [тип бонуса] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        return true;
    };
    BonusEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                bonus_ttl_hours: this.state.bonus_ttl_hours,
                title: this.state.title,
                description: this.state.description,
                is_bonus_has_ttl: this.state.is_bonus_has_ttl,
                is_deprecated: this.state.is_deprecated,
                is_locked: this.state.is_locked,
                //is_send_bonus_status_messages: this.state.is_send_bonus_status_messages,
                //bonus_status_message_set_id: this.state.bonus_status_message_set_id,
                //is_send_bonus_status_emails: this.state.is_send_bonus_status_emails,
                //bonus_status_email_set_id: this.state.bonus_status_email_set_id,
                is_use_freespin: this.state.is_use_freespin
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон бонуса изменен!");
            });
        }
    };
    BonusEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                // app_currency_id: this.state.app_currency_id,
                bonus_ttl_hours: this.state.bonus_ttl_hours,
                bonus_type_code: this.state.bonus_type_code,
                brand_id: this.state.brand_id,
                description: this.state.description,
                is_bonus_has_ttl: this.state.is_bonus_has_ttl,
                is_deprecated: this.state.is_deprecated,
                is_locked: this.state.is_locked,
                title: this.state.title,
                //is_send_bonus_status_messages: this.state.is_send_bonus_status_messages,
                //bonus_status_message_set_id: this.state.bonus_status_message_set_id,
                //is_send_bonus_status_emails: this.state.is_send_bonus_status_emails,
                //bonus_status_email_set_id: this.state.bonus_status_email_set_id,
                is_use_freespin: this.state.is_use_freespin
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон бонуса добавлен!");
            });
        }
    };
    BonusEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить шаблон бонуса";
        }
        else {
            return "Изменить шаблон бонуса";
        }
    };
    BonusEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) { _this.setState({ brand_id: newVal.key, brand_title: newVal.value, brand_rules: { isError: false } }); }, items: this.state._brands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип бонуса:", placeholder: "Выберите тип бонуса" }, value: { key: this.state.bonus_type_code, value: this.state.bonus_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_type_code: newVal.key,
                        bonus_type_title: newVal.value,
                        bonus_type_rules: { isError: false }
                    });
                }, items: this.state._bonus_types, disabled: this.props.record != null, required: true, rules: this.state.bonus_type_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус содержит фриспины", value: this.state.is_use_freespin, onChecked: function (checked) { _this.setState({ is_use_freespin: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус имеет время жизни", value: this.state.is_bonus_has_ttl, onChecked: function (checked) { _this.setState({ is_bonus_has_ttl: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Время жизни бонуса(час):", placeholder: "Введите время жизни бонуса" }, values: { max: 64000, min: 1, value: this.state.bonus_ttl_hours }, onValueChanged: function (newVal) { _this.setState({ bonus_ttl_hours: newVal }); }, disabled: !this.state.is_bonus_has_ttl }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус устарел", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getDownButtons()));
    };
    BonusEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainContent();
        }
        return null;
    };
    BonusEditor.prototype.render = function () {
        /*return (

            <TabEditorContainer
                onGoBackClick={this.OnGoBackClick.bind(this)}
                title={this.getFormTitle()}
                state={this.props.state}
                maxHeight={700}
                activeTabKey={this.state.tabKey}
                tabs={[
                    { key: this.key_main, tab: "Основные" },
                   // { key: this.key_messages, tab: "Уведомления" }
                ]}
                onTabChange={(key) => { this.setState({ tabKey: key }) }}
            >
                {this.getContent()}

            </TabEditorContainer>
        );*/
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 670 }, this.getContent()));
    };
    return BonusEditor;
}(React.Component));
exports.default = BonusEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/BonusTemplateEditor.tsx
// module id = 1901
// module chunks = 0